import { dashboardModule } from './modules/dashboard.js';
import { agentsModule } from './modules/agents.js';
import { resourcesModule } from './modules/resources.js';
import { tokensModule } from './modules/tokens.js';
import { templatesModule } from './modules/templates.js';
import { printersModule } from './modules/printers.js';
export { dashboardModule, agentsModule, resourcesModule, tokensModule, templatesModule, printersModule };
/** All VectorHub modules in sidebar/workspace display order. */
export const vectorhubModules = [
    dashboardModule,
    agentsModule,
    resourcesModule,
    templatesModule,
    printersModule,
    tokensModule,
];
//# sourceMappingURL=index.js.map